import { useState, useEffect } from 'react';
import axios from 'axios';
import { LARAVEL_API_PATH } from '../constants/path';
import { shouldShowConsentModal, REQUIRED_CONSENT_TYPES } from '../helpers';
import { 
    AvailableConsentTypesResponse, 
    ConsentVersions, 
    ConsentTypeInfo 
} from '../components/ConsentModal';

interface UseConsentCheckReturn {
    showModal: boolean;
    loading: boolean;
    consentTypesInfo: AvailableConsentTypesResponse | null;
    handleModalClose: () => void;
}

/**
 * Хук для проверки необходимости показа модального окна согласий
 * Проверяет версии документов на сервере и сравнивает с локальными версиями
 */
export const useConsentCheck = (): UseConsentCheckReturn => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(true);
    const [consentTypesInfo, setConsentTypesInfo] = useState<AvailableConsentTypesResponse | null>(null);

    useEffect(() => {
        const checkConsentVersions = async () => {
            // Проверяем наличие токена - если его нет, это страница логина
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                // Получаем доступные типы согласий с сервера
                const response = await axios.get<AvailableConsentTypesResponse>(
                    `${LARAVEL_API_PATH}consent-download/types/available`
                );

                if (!response.data || !response.data.types_info) {
                    setLoading(false);
                    return;
                }

                setConsentTypesInfo(response.data);

                // Извлекаем версии для обязательных типов согласий
                const serverVersions: ConsentVersions = {};
                
                REQUIRED_CONSENT_TYPES.forEach((consentType) => {
                    const typeInfo: ConsentTypeInfo | undefined = response.data.types_info[consentType];
                    if (typeInfo) {
                        serverVersions[consentType] = typeInfo.text_version;
                    }
                });

                // Проверяем, нужно ли показывать модальное окно
                const needsConsent = shouldShowConsentModal(serverVersions);
                setShowModal(needsConsent);

            } catch (error) {
                console.error('Error checking consent versions:', error);
                // В случае ошибки не показываем модальное окно
                setShowModal(false);
            } finally {
                setLoading(false);
            }
        };

        checkConsentVersions();
    }, []);

    const handleModalClose = () => {
        setShowModal(false);
    };

    return {
        showModal,
        loading,
        consentTypesInfo,
        handleModalClose
    };
};

